import api from "./api";

export class AuthApiService {
    static signup(email:any,password:any,name:any){
        return api.post('signup',{'email':email,'password':password,'user_name':name})
    }

    static signin(email:any,password:any){
        return api.post('login',{'email':email,'password':password})
    }

    static updateProfile(formdata:any,userId:any){
        return api.post(`prof/${userId}`,formdata,{
            headers:{
                'Content-Type': 'multipart/form-data',
            }
        })
    }

    static getProfile(userId:any){
        return api.get(`prof/${userId}`)
    }
}